export default "__VITE_ASSET__CKAEc1pv__"